import React, { useState } from 'react';
import './FinishSetup.scss';
import { Button } from 'react-bootstrap';

const UserTypeSelection = (props) => {
  const { goToClassSelection, setSelectedRole } = props;
  const [selectedType, setSelectedType] = useState('student');

  const userTypes = [
    {
      id: 'student',
      title: 'Student',
      description: 'Practise, learn and prepare for exams.',
      icon: '🐼',
      role: 1,
    },
    {
      id: 'teacher',
      title: 'Teacher',
      description: 'Create and manage assessments for selected class.',
      icon: '👨‍🏫',
      role: 3,
    },
    {
      id: 'institute',
      title: 'Institute',
      description: 'Create and manage assessments for multiple classes.',
      icon: '🏫',
      role: 6,
    },
  ];

  const handleContinue = () => {
    goToClassSelection();
  };

  return (
    <div className='UserTypeSelection__container'>
      <div className='UserTypeSelection__maxWidth'>
        <div className='UserTypeSelection__header mt-5 pt-3'>
          <h1 className='UserTypeSelection__title'>Select User Type</h1>
          <p className='UserTypeSelection__subtitle'>Choose how you want to use Mulyankan</p>
        </div>

        <div className='UserTypeSelection__options-container'>
          {userTypes.map((type) => (
            <div
              key={type.id}
              className={`UserTypeSelection__option-card ${
                selectedType === type.id ? 'UserTypeSelection__option-card--selected' : ''
              }`}
              onClick={() => {
                setSelectedType(type.id);
                setSelectedRole(type.role);
              }}
            >
              <div className='UserTypeSelection__icon'>{type.icon}</div>
              <div className='UserTypeSelection__content'>
                <h3 className='UserTypeSelection__option-title'>{type.title}</h3>
                <p className='UserTypeSelection__option-description'>{type.description}</p>
              </div>
              <div className='UserTypeSelection__radio'></div>
            </div>
          ))}
        </div>

        <Button
          variant='customPrimary'
          className='UserTypeSelection__continue-btn py-2'
          onClick={handleContinue}
        >
          Continue
        </Button>
      </div>
    </div>
  );
};

export default UserTypeSelection;
